import script from "./GroupModal.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupModal.vue?vue&type=script&setup=true&lang=js"

import "./GroupModal.vue?vue&type=style&index=0&id=dc012cc6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc012cc6"]])

export default __exports__